import axios from "../axios";
import { parseContentDispositionFilename } from "../../utils/http";

const api = {
  getPhysicalRiskReport(params, accessToken) {
    const config = {
      params: params,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get("/physical-risk-report", config).then(({ data }) => data);
  },
  getPhysicalRiskGreggsReport(params, accessToken) {
    const config = {
      params:params,
      headers:{"Authorization": `Bearer ${accessToken}`}
    };
    return axios.get("/physical-risk-report/greggs", config).then(({ data }) => data);
  },
  getPhysicalRiskMenziesReport(params, accessToken) {
    const config = {
      params:params,
      headers:{"Authorization": `Bearer ${accessToken}`}
    };
    return axios.get("/physical-risk-report/menzies", config).then(({ data }) => data);
  },
  exportSuppliersPhysicalRiskData(params, accessToken) {
    const config = {
      params: params,
      responseType: "arraybuffer",
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get("/physical-risk-report/export", config).then(({ data, headers }) => {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      const defaultFileName = parseContentDispositionFilename(
        headers["content-disposition"], "Suppliers physical risk data export");
      link.href = url;
      link.setAttribute("download", defaultFileName);
      document.body.appendChild(link);
      link.click();
      return true;
    });
  },

  getPhysicalRiskSuppliersList(accessToken) {
    const config = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.get("/physical-risk-report/datasets/suppliers", config).then(({ data }) => data);
  },

  getSupplierPhysicalRisk(params, accessToken) {
    const config = {
      params,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get("/physical-risk-report/datasets/summary", config).then(({ data }) => data);
  },

  getSupplierFinancialRisk(params, accessToken) {
    const config = {
      params,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get("/physical-risk-report/datasets/financial-risk", config).then(({ data }) => data);
  }
};

export default api;